import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MacauFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15588'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15588)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V0H0V14Z'
					fill='#079D7B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.347 6.06673C11.347 6.27103 11.3319 6.4692 11.3034 6.65805C11.3765 6.63605 11.4509 6.61506 11.5265 6.5952C12.7966 6.26167 13.9303 6.37172 14.0586 6.841C14.1746 7.26511 13.4297 7.83749 12.3477 8.18994C12.1565 7.63437 11.1784 7.46673 10.0006 7.46673C8.82141 7.46673 7.84246 7.63474 7.65283 8.19179C6.58545 7.83866 5.85392 7.27229 5.96891 6.85172C6.09722 6.38244 7.2309 6.27239 8.50106 6.60592C8.56775 6.62343 8.63349 6.64182 8.69818 6.66101C8.66943 6.47127 8.65412 6.2721 8.65412 6.06673C8.65412 4.77807 9.25695 3.7334 10.0006 3.7334C10.7442 3.7334 11.347 4.77807 11.347 6.06673ZM7.61962 8.40007L8.45282 8.40006C8.32085 8.37471 8.1862 8.34435 8.04994 8.30888C8.20316 8.31333 8.39216 8.32616 8.60842 8.34084C8.99993 8.36742 9.4808 8.40007 10.0006 8.40007C10.5203 8.40007 11.0012 8.36742 11.3927 8.34084C11.6008 8.32672 11.7837 8.3143 11.9337 8.30942C11.7927 8.34508 11.6536 8.37526 11.5175 8.40006L12.3815 8.40007L13.8101 8.40006C13.6971 8.73236 13.5451 9.04546 13.3597 9.3334H6.64141C6.45604 9.04546 6.30401 8.73236 6.19105 8.40006L7.61962 8.40007ZM10.0006 11.2001C10.9625 11.2001 11.8459 10.8504 12.5397 10.2667H7.46145C8.15521 10.8504 9.03862 11.2001 10.0006 11.2001Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 2.80003C10.2636 2.80003 10.4767 2.5911 10.4767 2.33337C10.4767 2.07563 10.2636 1.8667 10.0006 1.8667C9.73757 1.8667 9.52437 2.07563 9.52437 2.33337C9.52437 2.5911 9.73757 2.80003 10.0006 2.80003ZM6.19103 5.13337C6.45403 5.13337 6.66722 4.92443 6.66722 4.6667C6.66722 4.40897 6.45403 4.20003 6.19103 4.20003C5.92804 4.20003 5.71484 4.40897 5.71484 4.6667C5.71484 4.92443 5.92804 5.13337 6.19103 5.13337ZM14.2863 4.6667C14.2863 4.92443 14.0731 5.13337 13.8101 5.13337C13.5471 5.13337 13.3339 4.92443 13.3339 4.6667C13.3339 4.40897 13.5471 4.20003 13.8101 4.20003C14.0731 4.20003 14.2863 4.40897 14.2863 4.6667ZM12.3815 3.73337C12.6445 3.73337 12.8577 3.52443 12.8577 3.2667C12.8577 3.00897 12.6445 2.80003 12.3815 2.80003C12.1185 2.80003 11.9053 3.00897 11.9053 3.2667C11.9053 3.52443 12.1185 3.73337 12.3815 3.73337ZM8.0958 3.2667C8.0958 3.52443 7.8826 3.73337 7.61961 3.73337C7.35661 3.73337 7.14342 3.52443 7.14342 3.2667C7.14342 3.00897 7.35661 2.80003 7.61961 2.80003C7.8826 2.80003 8.0958 3.00897 8.0958 3.2667Z'
					fill='#FCD117'
				/>
			</g>
		</svg>
	);
};

export default MacauFlagIcon;
